import { useEffect, useState } from "react";
import { api } from "../../api";
import { trackEvent } from "../../analytics";
import { getPpeIcon } from "./pictograms";
import KitBuilder from "./KitBuilder";

const TASKS = [
  { id: "loading", label: "Loading / unloading tanker" },
  { id: "sampling", label: "Sampling / QC draw" },
  { id: "dosing", label: "Manual dosing / transfer" },
  { id: "maintenance", label: "Line / pump maintenance" },
];

export default function Ppe({ chemKey, chemName, onRequestQuote }) {
  const [task, setTask] = useState("loading");
  const [items, setItems] = useState([]);

  useEffect(() => {
    api.getPpe(chemKey, task).then((d) => setItems(d.items));
    trackEvent("ppe_task_viewed", { chemical: chemKey, task });
  }, [chemKey, task]);

  return (
    <section className="panel" id="ppe" data-testid="section-ppe">
      <div className="wrap">
        <div className="panel-head">
          <div className="eyebrow">Tool · PPE selector</div>
          <h2>PPE by task</h2>
          <p>Pick the task on the active substance to see the minimum protective kit. Below,
             build a printable pre-entry checklist card with duration + concentration modifiers.</p>
        </div>
        <div className="tool-grid">
          <div className="pill-list" data-testid="ppe-task-list">
            {TASKS.map((t) => (
              <button
                key={t.id}
                className={task === t.id ? "on" : ""}
                onClick={() => setTask(t.id)}
                data-testid={`ppe-task-${t.id}`}
              >
                {t.label}
              </button>
            ))}
          </div>
          <div>
            <div className="ppe-items" data-testid="ppe-items">
              {items.map((item, i) => {
                const Icon = getPpeIcon(item);
                return (
                  <div className="ppe-item" key={i} data-testid={`ppe-item-${i}`}>
                    <div className="ic"><Icon size={26} strokeWidth={1.6} /></div>
                    <div className="lbl">{item}</div>
                  </div>
                );
              })}
            </div>
            <button
              className="btn btn-brand btn-sm"
              style={{ marginTop: 16 }}
              onClick={() => onRequestQuote?.("ppe")}
              data-testid="ppe-request-quote"
            >
              Request a quote for {chemName}
            </button>
          </div>
        </div>

        <div className="sub-panel-head">
          <div className="eyebrow">Tool · Kit Builder</div>
          <h3>Pre-entry checklist card</h3>
          <p className="note">Print a signed card the supervisor keeps at the entry gate.</p>
        </div>

        <KitBuilder chemKey={chemKey} chemName={chemName} />
      </div>
    </section>
  );
}
